module.exports = __webpack_public_path__ + "img/海通乡.5444ef9c.png";